module.exports = __webpack_public_path__ + "img/11feef877.feef8777.png";